import Bomb from "./Bomb"
import Entity from "./Entity"
import Explosion from "./Explosion"
import Level from "./Level"
import Match from "./Match"
import { TILE_SIZE, SCALE_FACTOR } from "./config"
import { getAnimation } from "./spritesheet"

export enum PoisonEnum {
  diarrhea = "diarrhea",
  constipation = "constipation",
  lowPower = "lowPower",
  highPower = "highPower",
  slowed = "slowed"
}

export default class Poison extends Entity {
  static POISON_SIZE = TILE_SIZE * SCALE_FACTOR
  static POISON_DURATION = 8000
  static POISON_DIARRHEA_SPEED = 9
  static POISON_SLOWED_SPEED = 2
  static POISON_MIN_FIRE = 1
  static POISON_MAX_FIRE = 8

  type: PoisonEnum

  constructor(params: { x: number, y: number, level: Level, type: PoisonEnum }) {
    super({
      x: params.x,
      y: params.y,
      level: params.level,
      speed: 0,
      width: Poison.POISON_SIZE,
      height: Poison.POISON_SIZE,
      textures: getAnimation("poison"),
      staticTileCoords: true
    })

    this.type = params.type
    this.animationSpeed = 0.3
    this.play()
  }

  explode() {
    if (this.level instanceof Match && !this.level.started) return
    if (!this.alive) return
    super.explode()
    this.textures = getAnimation("powerUpExplosion")
    this.loop = false
    this.play()
    this.onComplete = () => {
      this.removeFromLevel()
    }
  }

  isBlocking(entityConstructor: typeof Entity.constructor): boolean {
    switch (entityConstructor) {
      case Explosion:
      case Bomb:
        return true
    }

    return false
  }

  toString() {
    return "Poison"
  }
}
